import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

const STATUS_STYLE = {
  pending:  { bg: '#fffbeb', color: '#92400e', icon: '⏳', label: 'Čeká na schválení' },
  approved: { bg: '#f0fdf4', color: '#166534', icon: '✅', label: 'Schváleno' },
  rejected: { bg: '#e8f4fc', color: '#991b1b', icon: '❌', label: 'Zamítnuto' },
  returned: { bg: '#f0f9ff', color: '#0369a1', icon: '📦', label: 'Vráceno' },
};

const inputStyle = {
  width: '100%', padding: '9px 12px', border: '1.5px solid #e5e7eb',
  borderRadius: 8, fontSize: 14, outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit',
};

function LoanItemsTable({ items, setItems, products }) {
  const addRow = () => setItems(prev => [...prev, { product_id: '', product_name: '', product_pn: '', quantity: 1 }]);
  const removeRow = (i) => setItems(prev => prev.filter((_, idx) => idx !== i));
  const updateRow = (i, k, v) => setItems(prev => prev.map((row, idx) => idx === i ? { ...row, [k]: v } : row));
  const selectProduct = (i, id) => {
    const p = products.find(p => String(p.id) === String(id));
    if (p) { updateRow(i, 'product_id', p.id); updateRow(i, 'product_name', p.name); updateRow(i, 'product_pn', p.sku || ''); }
  };

  return (
    <div style={{ marginBottom: 20 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
        <label style={{ fontSize: 13, fontWeight: 600, color: '#374151' }}>📦 Produkty k zapůjčení <span style={{ color: '#0e76bc' }}>*</span></label>
        <button type="button" onClick={addRow} style={{ background: 'linear-gradient(135deg, #0e76bc, #0b5e96)', color: '#fff', border: 'none', borderRadius: 6, padding: '5px 12px', fontSize: 12, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>+ Přidat produkt</button>
      </div>
      {items.length === 0 && (
        <div style={{ textAlign: 'center', padding: 20, color: '#9ca3af', background: '#f9fafb', borderRadius: 8, border: '1.5px dashed #e5e7eb', fontSize: 13 }}>Klikněte na "+ Přidat produkt"</div>
      )}
      {items.length > 0 && (
        <div style={{ border: '1.5px solid #e5e7eb', borderRadius: 8, overflow: 'hidden' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ background: '#f9fafb' }}>
                <th style={{ padding: '8px 12px', textAlign: 'left', fontWeight: 600, color: '#6b7280', borderBottom: '1px solid #e5e7eb' }}>Produkt</th>
                <th style={{ padding: '8px 12px', textAlign: 'left', fontWeight: 600, color: '#6b7280', borderBottom: '1px solid #e5e7eb', width: 80 }}>P/N</th>
                <th style={{ padding: '8px 12px', textAlign: 'left', fontWeight: 600, color: '#6b7280', borderBottom: '1px solid #e5e7eb', width: 90 }}>Množství</th>
                <th style={{ padding: '8px 12px', borderBottom: '1px solid #e5e7eb', width: 36 }}></th>
              </tr>
            </thead>
            <tbody>
              {items.map((row, i) => (
                <tr key={i} style={{ borderBottom: i < items.length - 1 ? '1px solid #f3f4f6' : 'none' }}>
                  <td style={{ padding: '8px 12px' }}>
                    <select value={row.product_id} onChange={e => selectProduct(i, e.target.value)} style={{ ...inputStyle, padding: '7px 10px' }}>
                      <option value="">-- Vyberte produkt --</option>
                      {products.map(p => <option key={p.id} value={p.id}>{p.name}{p.sku ? ` (${p.sku})` : ''}</option>)}
                    </select>
                  </td>
                  <td style={{ padding: '8px 12px', color: '#6b7280', fontSize: 12, fontFamily: 'monospace' }}>{row.product_pn}</td>
                  <td style={{ padding: '8px 12px' }}>
                    <input type="number" min="1" value={row.quantity} onChange={e => updateRow(i, 'quantity', parseInt(e.target.value) || 1)} style={{ ...inputStyle, width: 70, padding: '7px 10px', textAlign: 'center' }} />
                  </td>
                  <td style={{ padding: '8px 12px' }}>
                    <button type="button" onClick={() => removeRow(i)} style={{ background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: 18, lineHeight: 1, padding: 2 }}>×</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

function LoanForm({ onSubmit, onCancel, products, isAdmin, users }) {
  const [form, setForm] = useState({ purpose: '', delivery_address: '', date_requested_from: '', date_requested_to: '', on_behalf_of: '' });
  const [items, setItems] = useState(() => {
    try {
      const prefill = sessionStorage.getItem('prefillProducts');
      const type = sessionStorage.getItem('prefillType');
      if (prefill && type === 'loan') {
        sessionStorage.removeItem('prefillProducts');
        sessionStorage.removeItem('prefillType');
        return JSON.parse(prefill);
      }
    } catch(e) {}
    return [];
  });
  const [loading, setLoading] = useState(false);
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSubmit = async () => {
    const validItems = items.filter(i => i.product_id && i.quantity > 0);
    if (validItems.length === 0) { alert('Přidejte alespoň jeden produkt.'); return; }
    setLoading(true);
    await onSubmit({ ...form, items: validItems });
    setLoading(false);
  };

  return (
    <div style={{ background: '#fff', borderRadius: 12, padding: 28, boxShadow: '0 1px 6px rgba(0,0,0,0.06)', border: '1px solid #f3f4f6', marginBottom: 28 }}>
      <h2 style={{ margin: '0 0 24px', fontSize: 18, fontWeight: 700, color: '#111827' }}>Nová žádost o zápůjčku</h2>

      <LoanItemsTable items={items} setItems={setItems} products={products} />

      {isAdmin && users.length > 0 && (
        <div style={{ marginBottom: 20, padding: '14px 16px', background: '#e8f4fc', borderRadius: 8, border: '1px solid #b3d9f2' }}>
          <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#0e76bc', marginBottom: 5 }}>👤 Zadat jménem uživatele (admin)</label>
          <select value={form.on_behalf_of} onChange={e => set('on_behalf_of', e.target.value ? Number(e.target.value) : '')} style={{ width: '100%', padding: '9px 12px', border: '1.5px solid #e5e7eb', borderRadius: 8, fontSize: 14, fontFamily: 'inherit', background: '#fff', boxSizing: 'border-box' }}>
            <option value="">-- Vlastní účet (admin) --</option>
            {users.filter(u => u.role !== 'admin').map(u => (
              <option key={u.id} value={u.id}>{u.first_name} {u.last_name} – {u.company_name} ({u.email})</option>
            ))}
          </select>
        </div>
      )}

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 20px' }}>
        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 5 }}>Požadované datum od</label>
          <input type="date" value={form.date_requested_from} onChange={e => set('date_requested_from', e.target.value)} style={inputStyle} />
        </div>
        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 5 }}>Požadované datum do</label>
          <input type="date" value={form.date_requested_to} onChange={e => set('date_requested_to', e.target.value)} style={inputStyle} />
        </div>
        <div style={{ marginBottom: 16, gridColumn: '1 / -1' }}>
          <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 5 }}>Adresa pro doručení</label>
          <input type="text" value={form.delivery_address} onChange={e => set('delivery_address', e.target.value)} style={inputStyle} placeholder="Ulice, město, PSČ" />
        </div>
        <div style={{ marginBottom: 16, gridColumn: '1 / -1' }}>
          <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 5 }}>Účel / popis</label>
          <textarea value={form.purpose} onChange={e => set('purpose', e.target.value)} rows={3} style={{ ...inputStyle, resize: 'vertical' }} placeholder="Popište účel zápůjčky..." />
        </div>
      </div>

      <div style={{ display: 'flex', gap: 12 }}>
        <button onClick={handleSubmit} disabled={loading || items.length === 0} style={{ background: 'linear-gradient(135deg, #0e76bc, #0b5e96)', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 22px', fontSize: 14, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit', opacity: loading || items.length === 0 ? 0.5 : 1 }}>Odeslat žádost</button>
        <button onClick={onCancel} style={{ background: '#f9fafb', color: '#374151', border: '1px solid #e5e7eb', borderRadius: 8, padding: '10px 18px', fontSize: 14, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>Zrušit</button>
      </div>
    </div>
  );
}

function EditLoanInline({ loan, onSave, onCancel }) {
  const [status, setStatus] = useState(loan.status);
  const [note, setNote] = useState(loan.admin_note || '');
  const [dateLoaned, setDateLoaned] = useState(loan.date_loaned || '');
  const [dateReturned, setDateReturned] = useState(loan.date_returned || '');
  const [i6, setI6] = useState(loan.i6_reference || '');

  return (
    <div style={{ marginTop: 14, paddingTop: 14, borderTop: '1px solid #f3f4f6', display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'flex-end' }}>
      <div>
        <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>Stav</label>
        <select value={status} onChange={e => setStatus(e.target.value)} style={{ padding: '7px 10px', border: '1.5px solid #e5e7eb', borderRadius: 7, fontSize: 13, background: '#fff', fontFamily: 'inherit' }}>
          {Object.entries(STATUS_STYLE).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}
        </select>
      </div>
      <div>
        <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>Datum zapůjčení</label>
        <input type="date" value={dateLoaned} onChange={e => setDateLoaned(e.target.value)} style={{ padding: '7px 10px', border: '1.5px solid #e5e7eb', borderRadius: 7, fontSize: 13, fontFamily: 'inherit' }} />
      </div>
      <div>
        <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>Datum vrácení</label>
        <input type="date" value={dateReturned} onChange={e => setDateReturned(e.target.value)} style={{ padding: '7px 10px', border: '1.5px solid #e5e7eb', borderRadius: 7, fontSize: 13, fontFamily: 'inherit' }} />
      </div>
      <div style={{ flex: 1, minWidth: 200 }}>
        <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>Poznámka</label>
        <input value={note} onChange={e => setNote(e.target.value)} style={{ width: '100%', padding: '7px 10px', border: '1.5px solid #e5e7eb', borderRadius: 7, fontSize: 13, fontFamily: 'inherit', boxSizing: 'border-box' }} />
      </div>
      <div style={{ flex: 1, minWidth: 160 }}>
        <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#0369a1', marginBottom: 4 }}>Zápůjčka v i6</label>
        <input value={i6} onChange={e => setI6(e.target.value)} placeholder="Reference v i6..." style={{ width: '100%', padding: '7px 10px', border: '1.5px solid #bae6fd', borderRadius: 7, fontSize: 13, fontFamily: 'inherit', boxSizing: 'border-box', background: '#f0f9ff' }} />
      </div>
      <button onClick={() => onSave({ status, admin_note: note, date_loaned: dateLoaned, date_returned: dateReturned, i6_reference: i6 })} style={{ background: 'linear-gradient(135deg, #0e76bc, #0b5e96)', color: '#fff', border: 'none', borderRadius: 8, padding: '9px 18px', fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>Uložit</button>
      <button onClick={onCancel} style={{ background: '#f9fafb', color: '#374151', border: '1px solid #e5e7eb', borderRadius: 8, padding: '9px 14px', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>Zrušit</button>
    </div>
  );
}

export default function LoansPage() {
  const { user, apiFetch } = useAuth();
  const isAdmin = user?.role === 'admin';
  const [loans, setLoans] = useState([]);
  const [products, setProducts] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(() => {
    return sessionStorage.getItem('prefillType') === 'loan' ||
           !!sessionStorage.getItem('prefillProducts');
  });
  const [editing, setEditing] = useState(null);
  const [toast, setToast] = useState(null);

  const load = () => Promise.all([
    apiFetch('/loans'),
    apiFetch('/products'),
    isAdmin ? apiFetch('/admin/users') : Promise.resolve([]),
  ]).then(([l, p, u]) => { setLoans(l); setProducts(p); if (isAdmin) setUsers(u); }).finally(() => setLoading(false));

  useEffect(() => { load(); }, []);

  const showToast = (msg, type = 'success') => { setToast({ msg, type }); setTimeout(() => setToast(null), 4000); };

  const handleSubmit = async (form) => {
    try {
      await apiFetch('/loans', { method: 'POST', body: JSON.stringify(form) });
      showToast('Žádost o zápůjčku byla odeslána.');
      setShowForm(false); load();
    } catch (e) { showToast(e.message, 'error'); }
  };

  const handleSaveEdit = async (id, data) => {
    try {
      await apiFetch(`/admin/loans/${id}`, { method: 'PUT', body: JSON.stringify(data) });
      setEditing(null); load();
    } catch (e) { showToast(e.message, 'error'); }
  };

  if (loading) return <div style={{ textAlign: 'center', padding: 60, color: '#9ca3af' }}>Načítám...</div>;

  const locale = 'cs-CZ';
  const fmt = (d) => d ? new Date(d).toLocaleDateString(locale) : '—';

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
        <h1 style={{ margin: 0, fontSize: 26, fontWeight: 800, color: '#111827' }}>🔄 Zápůjčky</h1>
        {!showForm && (
          <button onClick={() => setShowForm(true)} style={{ background: 'linear-gradient(135deg, #0e76bc, #0b5e96)', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 18px', fontSize: 14, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>
            + Nová žádost
          </button>
        )}
      </div>
      <p style={{ margin: '0 0 24px', color: '#6b7280', fontSize: 14 }}>Žádosti o zapůjčení produktů k otestování</p>

      {toast && (
        <div style={{ position: 'fixed', top: 80, right: 24, background: toast.type === 'error' ? '#e8f4fc' : '#f0fdf4', border: `1px solid ${toast.type === 'error' ? '#b3d9f2' : '#bbf7d0'}`, color: toast.type === 'error' ? '#dc2626' : '#166534', borderRadius: 10, padding: '14px 20px', boxShadow: '0 4px 16px rgba(0,0,0,0.1)', zIndex: 999, fontSize: 14, fontWeight: 500 }}>{toast.msg}</div>
      )}

      {showForm && <LoanForm onSubmit={handleSubmit} onCancel={() => setShowForm(false)} products={products} isAdmin={isAdmin} users={users} />}

      {loans.length === 0 && !showForm ? (
        <div style={{ textAlign: 'center', padding: 60, color: '#9ca3af' }}>Žádné zápůjčky.</div>
      ) : (
        <div style={{ display: 'grid', gap: 14 }}>
          {loans.map(l => {
            const s = STATUS_STYLE[l.status] || STATUS_STYLE.pending;
            return (
              <div key={l.id} style={{ background: '#fff', borderRadius: 12, padding: '20px 24px', boxShadow: '0 1px 6px rgba(0,0,0,0.06)', border: '1px solid #f3f4f6', borderLeft: `4px solid ${s.color}` }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12 }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6, flexWrap: 'wrap' }}>
                      <span style={{ background: s.bg, color: s.color, fontSize: 12, fontWeight: 700, padding: '2px 10px', borderRadius: 20 }}>{s.icon} {s.label}</span>
                      {isAdmin && l.company_name && <span style={{ background: '#f0f9ff', color: '#0369a1', fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 10 }}>{l.company_name}</span>}
                      {isAdmin && l.user_name && <span style={{ fontSize: 12, color: '#6b7280' }}>{l.user_name}</span>}
                    </div>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px 20px', fontSize: 13, color: '#6b7280', marginBottom: 8 }}>
                      {l.date_requested_from && <span>📅 Od: {fmt(l.date_requested_from)}</span>}
                      {l.date_requested_to && <span>📅 Do: {fmt(l.date_requested_to)}</span>}
                      {l.date_loaned && <span style={{ color: '#166534' }}>✓ Zapůjčeno: {fmt(l.date_loaned)}</span>}
                      {l.date_returned && <span style={{ color: '#0369a1' }}>↩ Vráceno: {fmt(l.date_returned)}</span>}
                      {l.delivery_address && <span>📍 {l.delivery_address}</span>}
                      <span>🕐 {new Date(l.created_at).toLocaleDateString(locale)}</span>
                    </div>
                    {l.purpose && <p style={{ margin: '0 0 8px', fontSize: 13, color: '#374151' }}>💬 {l.purpose}</p>}

                    {l.items && l.items.length > 0 && (
                      <div style={{ border: '1px solid #f3f4f6', borderRadius: 8, overflow: 'hidden' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                          <thead>
                            <tr style={{ background: '#f9fafb' }}>
                              <th style={{ padding: '6px 12px', textAlign: 'left', color: '#6b7280', fontWeight: 600, borderBottom: '1px solid #f3f4f6' }}>Produkt</th>
                              <th style={{ padding: '6px 12px', textAlign: 'left', color: '#6b7280', fontWeight: 600, borderBottom: '1px solid #f3f4f6' }}>P/N</th>
                              <th style={{ padding: '6px 12px', textAlign: 'center', color: '#6b7280', fontWeight: 600, borderBottom: '1px solid #f3f4f6' }}>Množství</th>
                            </tr>
                          </thead>
                          <tbody>
                            {l.items.map((item, i) => (
                              <tr key={i} style={{ borderBottom: i < l.items.length - 1 ? '1px solid #f9fafb' : 'none' }}>
                                <td style={{ padding: '6px 12px', fontWeight: 600, color: '#111827' }}>{item.product_name}</td>
                                <td style={{ padding: '6px 12px', color: '#9ca3af', fontSize: 12, fontFamily: 'monospace' }}>{item.product_pn}</td>
                                <td style={{ padding: '6px 12px', textAlign: 'center', fontWeight: 700, color: '#374151' }}>{item.quantity}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}

                    {l.admin_note && <div style={{ marginTop: 10, padding: '8px 12px', background: '#f9fafb', borderRadius: 6, fontSize: 13, color: '#374151', borderLeft: '3px solid #e5e7eb' }}>💬 {l.admin_note}</div>}
                    {isAdmin && l.i6_reference && <div style={{ marginTop: 6, padding: '8px 12px', background: '#f0f9ff', borderRadius: 6, fontSize: 13, color: '#0369a1', borderLeft: '3px solid #bae6fd', fontWeight: 600 }}>🔗 i6: {l.i6_reference}</div>}

                    {isAdmin && editing === l.id && (
                      <EditLoanInline loan={l} onSave={(data) => handleSaveEdit(l.id, data)} onCancel={() => setEditing(null)} />
                    )}
                  </div>

                  {isAdmin && (
                    <button onClick={() => setEditing(editing === l.id ? null : l.id)} style={{ background: editing === l.id ? '#e8f4fc' : '#f9fafb', border: '1px solid #e5e7eb', color: editing === l.id ? '#0e76bc' : '#374151', borderRadius: 8, padding: '7px 14px', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit', flexShrink: 0 }}>
                      {editing === l.id ? 'Zavřít' : 'Vyřídit'}
                    </button>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
